import { FC } from 'react';
import { Popover, Skeleton } from 'antd';
import { ReassignIcon } from '@dynamika-shared/ui/icons';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';
import { twMerge } from '@utils/twMerge';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { useParams } from 'react-router-dom';
import { useQCTaskSlice } from '@restore/QCTask/QCTask.slice';

export const QcVisitAssignee: FC<{
  taskIsCompleted: boolean;
  isTaskAssignedToCurrentUser: boolean;
}> = ({ taskIsCompleted, isTaskAssignedToCurrentUser }) => {
  const { id: clinicalTrialId, taskId } = useParams<{
    id: string;
    taskId: string;
  }>();

  const [taskData, assign, assignLoading, taskDataIsLoading] = useQCTaskSlice(
    (state, actions) => [
      state.data,
      actions.assign,
      state.assignLoading,
      state.loading,
    ]
  );

  const assignPopoverIsDisabled = {
    ...(taskIsCompleted && { open: false }),
  };

  const isDisabled = !taskData || taskDataIsLoading || taskIsCompleted;

  const assignToMe = async () => {
    if (clinicalTrialId && taskId) {
      assign({ clinicalTrialId, taskId });
    }
  };

  return (
    <div className='flex items-center gap-1'>
      <div className='flex'>
        <div className='text-dimGray'>Assignee</div>:{' '}
        <div className='font-medium max-w-md truncate ml-1'>
          {taskData?.assigneeName}
        </div>
      </div>
      {taskData?.assigneeName && !isTaskAssignedToCurrentUser && (
        <Popover
          {...assignPopoverIsDisabled}
          placement='bottom'
          content={
            <div
              className='flex cursor-pointer items-center gap-1 rounded p-1 hover:bg-gray-300 hover:text-black'
              onKeyDown={() => {}}
              onClick={assignToMe}
            >
              <ReassignIcon className='text-[20px]' />{' '}
              <span className='text-1424 font-medium'>Reassign to me</span>
            </div>
          }
          trigger='click'
        >
          <ChevronIcon
            className={twMerge(
              'b-1 h-2 w-2 cursor-pointer rounded-full border',
              taskIsCompleted && 'opacity-30'
            )}
            classNameButton='h-3 w-3'
            dir='down'
          />
        </Popover>
      )}
      {assignLoading && <Skeleton.Input active size={'small'} />}
      {!taskData?.assigneeName && !assignLoading && (
        <Button
          type='text'
          className={twMerge(
            'text-vividTangelo hover:text-honoluluBlue !font-medium without-bg -ml-2',
            isDisabled && '!text-dimGray !hover:text-dimGray'
          )}
          disabled={isDisabled}
          onClick={assignToMe}
        >
          + Assign to me
        </Button>
      )}
    </div>
  );
};
